import localforage from "localforage";
import { convertGroupidToGroup } from "./conversions";
import {getFileTypes} from "./files"

export const getFitDocToken = (user) => {
    let token = "";

    if(parseFloat(user.role) === 1){
        //Admin
        token = process.env.REACT_APP_FITDOC_ADMTOK;
    }
    else if(parseFloat(user.role) === 2){
        //EM
        token = process.env.REACT_APP_FITDOC_EMTOK;
    }
    else if(parseFloat(user.role) === 3){
        //Afnemer
        token = process.env.REACT_APP_FITDOC_AFTOK;
    }
    else if(parseFloat(user.role) === 4){
        //Aanbieder
        token = process.env.REACT_APP_FITDOC_ABTOK;
    }

    return token;
}

const calculateGroupMetafilter = async (user) => {
    if(!user) return;
    if(!user.group) return;
    if(!user.role) return;

    const group = await convertGroupidToGroup(user.group, user)
    if(group){
        if(group.members){
            let userRelnr = user.relnr;

            if(!group.members.includes(parseFloat(userRelnr)) && !group.members.includes(userRelnr)){
                group.members.push(userRelnr)
            }
        } 
        let relnrs = "";
        if(group){relnrs = await group?.members?.join("|")}
        let metafilter = "";
        if(parseFloat(user.role) === 2){
            //EM
            metafilter = "RELNR_EM="+relnrs;
        }
        else if(parseFloat(user.role) === 3){
            //Afnemer
            metafilter = "RELNR_AF="+relnrs;
        }
        else if(parseFloat(user.role) === 4){
            //Aanbieder
            metafilter = "RELNR_AB="+relnrs;
        }
        return metafilter;
    }
    else{
        if(parseFloat(user.role) === 2){
            //EM
            return "RELNR_EM="+user.relnr;
        }
        else if(parseFloat(user.role) === 3){
            //Afnemer
            return "RELNR_AF="+user.relnr;
        }
        else if(parseFloat(user.role) === 4){
            //Aanbieder
            return "RELNR_AB="+user.relnr;
        }
    }
}

// function convertMetaFormat(input) {
//     // Split the input string by semicolon to get key-value pairs
//     const pairs = input.split(';');

//     // Create an object to store unique keys with concatenated values
//     const result = {};

//     pairs.forEach(pair => {
//         // Split each pair by '=' to get the key and value
//         const [key, value] = pair.split('=');

//         // If the key already exists, concatenate the new value with '|'
//         if (result[key]) {
//             result[key] += '|' + value;
//         } else {
//             // If the key does not exist, simply add it to the object
//             result[key] = value;
//         }
//     });

//     // Convert the object back to a string format
//     const output = Object.keys(result).map(key => `${key}=${result[key]}`).join(';');

//     return output;
// }

function combineAndConvertFormat(input1, input2) {
    // Function to process input strings into an object with unique values
    function processInput(input) {
        const result = {};

        // Split input by ';' to get key-value pairs
        const pairs = input.split(';');

        pairs.forEach(pair => {
            // Further split by '=' to get key and values
            const [key, values] = pair.split('=');
            if (key && values) {
                // Split values by '|' to handle multiple values for a single key
                const valueArray = values.split('|');

                if (!result[key]) {
                    result[key] = new Set();
                }

                // Add each value to the Set to avoid duplicates
                valueArray.forEach(value => {
                    result[key].add(value);
                });
            }
        });

        return result;
    }

    // Process both inputs into objects
    const result1 = processInput(input1);
    const result2 = processInput(input2);

    // Combine results from both inputs
    const combinedResult = { ...result1 };

    Object.keys(result2).forEach(key => {
        if (!combinedResult[key]) {
            combinedResult[key] = new Set();
        }
        result2[key].forEach(value => {
            combinedResult[key].add(value);
        });
    });

    // Convert the combined result back into the desired output format
    const output = Object.keys(combinedResult).map(key => {
        const values = Array.from(combinedResult[key]).join('|');
        return `${key}=${values}`;
    }).join(';');

    return output;
}

export const getFitDocMetafilter = async (user) =>{

    let relnr_v = user.relnr;
    let role_v = user.role;

    // Convert to array and add 000's if not in front
    relnr_v = relnr_v.split(';').map(r => { 
        if(r.substring(0,3) !== '000'){ 
            return `000${r}`
        } else { 
            return r 
        } 
    })

    // Convert to array
    role_v = role_v.split(';')

    let meta = [];

    role_v.forEach((role, index) => {
        const prevSameRole = role_v[index-1] === role
        switch (role) {
            case "1":
                // Admin ; do nothing
                break;
            case "2":
                // EM
                if(!prevSameRole) meta.push(`RELNR_EM=${relnr_v[index]}`)
                else { meta[index-1] = `${meta[index-1]}|${relnr_v[index]}` }
                break;
            case "3":
                // AF
                if(!prevSameRole) meta.push(`RELNR_AF=${relnr_v[index]}`)
                else { meta[index-1] = `${meta[index-1]}|${relnr_v[index]}` }
                break;
            case "4":
                // AF
                if(!prevSameRole) meta.push(`RELNR_AB=${relnr_v[index]}`)
                else { meta[index-1] = `${meta[index-1]}|${relnr_v[index]}` }
                break;
            default:
                break;
        }
    })

    const groupMeta = await calculateGroupMetafilter(user) || ''

    return (combineAndConvertFormat(meta.join(';'), groupMeta)).split(';')
    

    let metafilter = "";

    let relnr = user.relnr.toString();
    if(relnr.substring(0,3) !== "000"){
        relnr = "000"+relnr;
    }

    //console.log(user);


    if(parseFloat(user.role) === 2){
        //EM
        metafilter = "RELNR_EM="+relnr;
    }
    else if(parseFloat(user.role) === 3){
        //Afnemer
        metafilter = "RELNR_AF="+relnr;
    }
    else if(parseFloat(user.role) === 4){
        //Aanbieder
        metafilter = "RELNR_AB="+relnr;
    }

    if(parseFloat(user.group) > 0){
        return calculateGroupMetafilter(user);
    }

    return metafilter;
}

export const getFitDocTypes = async () =>{
    let lfTableItems = await localforage.getItem("tableItems");
    let types = [];
    if(lfTableItems){
        types = lfTableItems
    }
    else{
        const resAdminSettings = await fetch(process.env.REACT_APP_SERVER_LINK+"adminSettingsGet?token="+window.localStorage.getItem("token"), {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        let resultAdminSettings = await resAdminSettings.json();
        if(resultAdminSettings.object){
            if(resultAdminSettings.object.json){
                if(resultAdminSettings.object.json.table_items){
                    types = (resultAdminSettings.object.json.table_items)
                    localforage.setItem("tableItems", resultAdminSettings.object.json.table_items)
                    window.localStorage.setItem("enabledDoctypes", types);
                }        
            }
        }
    }
    return types;
}